import { jsx as _jsx } from "react/jsx-runtime";
import '../Review/Review.scss';
import MarketingSidebar from './MarketingSidebar';
import PriceEstimate from './PriceEstimate';
export default function Sidebar(_a) {
    var order = _a.order, step = _a.step;
    if (step !== 0 && step !== 3) {
        return _jsx(PriceEstimate, { order: order });
    }
    return _jsx(MarketingSidebar, {});
}
